var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalayticsReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#12A8A8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3574 10H23.3583V22.5C23.3583 23.3284 22.6868 24 21.8583 24H12.3574V10Z",
    stroke: "#12A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.25H12.3573V24H11.5C10.6716 24 10 23.3284 10 22.5V15.25Z",
    stroke: "#12A8A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.929 17H17.0721",
    stroke: "#12A8A8",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.875H22",
    stroke: "#12A8A8",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.875H22",
    stroke: "#12A8A8",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6647 14.9584C18.6647 15.4784 19.0257 15.8965 19.4686 15.8965H20.3736C20.7587 15.8965 21.0716 15.532 21.0716 15.0764C21.0716 14.5886 20.879 14.4117 20.595 14.2991L19.1461 13.7363C18.862 13.6237 18.6695 13.4522 18.6695 12.959C18.6695 12.5088 18.9824 12.1389 19.3675 12.1389H20.2725C20.7154 12.1389 21.0764 12.557 21.0764 13.077",
    stroke: "#12A8A8",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8683 11.6082V16.4325",
    stroke: "#12A8A8",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalayticsReport);
export default __webpack_public_path__ + "static/media/AnalayticsReport.b3c4f4246ef4dd8565d293456c050232.svg";
export { ForwardRef as ReactComponent };